<template>
  <b-modal
    v-model="isOpen"
    title="Article Citation"
    size="lg"
    scrollable
  >
    <!-- Vancouver -->
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h6 class="mb-0 font-weight-bold">Vancouver</h6>
      <b-button
        variant="outline-primary"
        size="sm"
        v-b-tooltip.hover
        title="Copy Vancouver"
        @click="copyCitation('vancouver')"
      >
        Copy
      </b-button>
    </div>
    <pre
      class="bg-light p-3 rounded mb-4 text-wrap"
      style="cursor: pointer;"
      title="Click to copy"
      @click="copyCitation('vancouver')"
    >{{ citations.vancouver }}</pre>

    <!-- APA 7 -->
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h6 class="mb-0 font-weight-bold">APA 7</h6>
      <b-button
        variant="outline-primary"
        size="sm"
        v-b-tooltip.hover
        title="Copy APA 7"
        @click="copyCitation('apa')"
      >
        Copy
      </b-button>
    </div>
    <pre
      class="bg-light p-3 rounded mb-4 text-wrap"
      style="cursor: pointer;"
      title="Click to copy"
      @click="copyCitation('apa')"
    >{{ citations.apa }}</pre>

    <!-- Harvard -->
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h6 class="mb-0 font-weight-bold">Harvard</h6>
      <b-button
        variant="outline-primary"
        size="sm"
        v-b-tooltip.hover
        title="Copy Harvard"
        @click="copyCitation('harvard')"
      >
        Copy
      </b-button>
    </div>
    <pre
      class="bg-light p-3 rounded mb-4 text-wrap"
      style="cursor: pointer;"
      title="Click to copy"
      @click="copyCitation('harvard')"
    >{{ citations.harvard }}</pre>

    <!-- BibTeX -->
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h6 class="mb-0 font-weight-bold">BibTeX</h6>
      <b-button
        variant="outline-primary"
        size="sm"
        v-b-tooltip.hover
        title="Copy BibTeX"
        @click="copyCitation('bibtex')"
      >
        Copy
      </b-button>
    </div>
    <pre
      class="bg-light p-3 rounded mb-0 text-wrap"
      style="cursor: pointer;"
      title="Click to copy"
      @click="copyCitation('bibtex')"
    >{{ citations.bibtex }}</pre>

    <!-- Custom Footer with Close Button -->
    <template #modal-footer="{ close }">
      <b-button variant="secondary" @click="close()">Close</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'CitationModal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      citations: {
        vancouver: 'Forbes C, Greenwood H, Carter M, Clark J. Automation of duplicate record detection for systematic reviews: Deduplicator. Syst Rev. 2024 Aug 2;13(1):206. doi: 10.1186/s13643-024-02619-9.',
        apa: 'Forbes, C., Greenwood, H., Carter, M., & Clark, J. (2024). Automation of duplicate record detection for systematic reviews: Deduplicator. Systematic Reviews, 13(1), 206. https://doi.org/10.1186/s13643-024-02619-9',
        harvard: 'Forbes, C., Greenwood, H., Carter, M. and Clark, J., 2024. Automation of duplicate record detection for systematic reviews: Deduplicator. Systematic Reviews, 13(1), p.206. Available at: https://doi.org/10.1186/s13643-024-02619-9.',
        bibtex: `@article{forbes2024deduplicator,
  title={Automation of duplicate record detection for systematic reviews: Deduplicator},
  author={Forbes, Connor and Greenwood, Hannah and Carter, Matt and Clark, Justin},
  journal={Systematic Reviews},
  volume={13},
  number={1},
  pages={206},
  year={2024},
  publisher={BioMed Central},
  doi={10.1186/s13643-024-02619-9},
  url={https://doi.org/10.1186/s13643-024-02619-9}
}`
      }
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    copyCitation(type) {
      const textToCopy = this.citations[type];

      // Modern Clipboard API approach with fallback for older browsers
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(textToCopy)
          .then(() => this.showToast('Success', 'Citation copied to clipboard', 'success'))
          .catch(() => this.showToast('Error', 'Failed to copy citation', 'danger'));
      } else {
        // Fallback for older browsers
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        textArea.style.position = "fixed";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          this.showToast('Success', 'Citation copied to clipboard', 'success');
        } catch (err) {
          this.showToast('Error', 'Failed to copy citation', 'danger');
        }
        document.body.removeChild(textArea);
      }
    },
    showToast(title, message, variant) {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000
      });
    }
  }
}
</script>